import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { KendoModule } from './kendo/kendo.module';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from './pipes/pipe.module';
import { DirectiveModule } from './directives/directives.module';
import { MessageService } from './services';
import {
  ColumnComponent,
  DataGridComponent,
  GridManagerToolbarComponent,
  FontSizeManagerComponent,
  ColumnManagerComponent,
  ImporterComponent,
  GridPercentageFilterMenuComponent,
  TriStateSwitchComponent,
  ValidationResultComponent,
  EditableColumnComponent,
  FilterCellComponent,
  FilterMenuComponent,
  CustomFilterComponent,
  ItemFilterComponent,
} from './components';
import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-94932e736d/icons';
import * as lightIcons from '@awesome.me/kit-94932e736d/icons/classic/light';

@NgModule({
  declarations: [
    ColumnComponent,
    EditableColumnComponent,
    FilterCellComponent,
    FilterMenuComponent,
    CustomFilterComponent,
    ItemFilterComponent,
    DataGridComponent,
    GridManagerToolbarComponent,
    FontSizeManagerComponent,
    ColumnManagerComponent,
    ImporterComponent,
    GridPercentageFilterMenuComponent,
    TriStateSwitchComponent,
    ValidationResultComponent,
  ],
  providers: [MessageService],
  imports: [
    FontAwesomeModule,
    CommonModule,
    RouterModule,
    FormsModule,
    KendoModule,
    MaterialModule,
    PipeModule,
    DirectiveModule,
    ReactiveFormsModule,
  ],
  exports: [
    FontAwesomeModule,
    ColumnComponent,
    EditableColumnComponent,
    DataGridComponent,
    CustomFilterComponent,
    ItemFilterComponent,
    GridManagerToolbarComponent,
    ImporterComponent,
    ValidationResultComponent,
    CommonModule,
    RouterModule,
    FormsModule,
    KendoModule,
    MaterialModule,
    PipeModule,
    DirectiveModule,
    ReactiveFormsModule
  ],
})
export class BaseModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(...all);
    library.addIcons(...Object.values(lightIcons));
  }
}
